var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-breadcrumb",
    {
      staticClass: "def-w layout-breadcrumb f-start-c",
      attrs: { "separator-class": "el-icon-arrow-right" },
    },
    _vm._l(_vm.breadcrumbList, function (menu) {
      return _c(
        "el-breadcrumb-item",
        { key: menu.id, attrs: { to: _vm.getRoute(menu) } },
        [
          menu.isQuery
            ? _c("div", { staticClass: "search-item" }, [
                _vm._v(" " + _vm._s(menu.name) + " "),
                _c("i", { staticClass: "el-icon-close" }),
              ])
            : [_vm._v(" " + _vm._s(menu.name) + " ")],
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }